import { IHomepageState } from '../interfaces/HomepageState';

type WithHomepageState = {
  HomepageSlice: IHomepageState;
};

export const UsefulResourcesStateSelector = (
  state: WithHomepageState,
): IHomepageState => state.HomepageSlice;
